/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './AccessRpc';
import * as Queries from './AccessRpc.dfc.new';
import type { AdditionalContextArgs } from './AccessRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseLoginVerifyQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.LoginVerifyResponseType>,
    References.LoginVerifyRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'loginVerify', References.LoginVerifyResponseType>
        : References.LoginVerifyResponseType)
    | undefined;
};

export function useLoginVerifyQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.LoginVerifyResponseType>,
    References.LoginVerifyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseLoginVerifyQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.LOGIN_VERIFY_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            loginVerify: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseLoginVerifyQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseLoginVerifyQueryReturn<T>;
}

type UseLoginVerifyLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.LoginVerifyResponseType>,
    References.LoginVerifyRequestType,
    T extends true
      ? Record<'loginVerify', References.LoginVerifyResponseType>
      : References.LoginVerifyResponseType
  >;

export function useLoginVerifyLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.LoginVerifyResponseType>,
    References.LoginVerifyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseLoginVerifyLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LOGIN_VERIFY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            loginVerify: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseLoginVerifyLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseLoginVerifyLazyQueryReturn<T>;
}

type UseLoginVerifySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.LoginVerifyResponseType>,
    References.LoginVerifyRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'loginVerify', References.LoginVerifyResponseType>
    : References.LoginVerifyResponseType;
};

export function useLoginVerifySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.LoginVerifyResponseType>,
    References.LoginVerifyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseLoginVerifySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LOGIN_VERIFY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            loginVerify: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseLoginVerifySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseLoginVerifySuspenseQueryReturn<T>;
}
